import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import Carousel3d from 'vue-carousel-3d'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#0038a8',
    secondary: '#646464',
    accent: '#3ea9cf',
    error: '#c3003b',
    info: '#fada31',
    success: '#4CAF50',
    warning: '#FFC107',
    // -------------black friday edition parametrized on DB-------------//
    bFBackground: '#ffffff',
    bFTitleColor: '#0033cc',
    bFTextColor: '#000000',
    bFBtnColor: '#0033cc',
    bFBtnTxtColor: '#FFC107',
    bFDividerColor: '#0033cc'
  },
})
Vue.use(Carousel3d)
